import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAttribute } from "src/models/General/Attribute.models";

interface AttributeState {
  attributes: IAttribute[];
  attributeToEdit: IAttribute | null;
}

const initialState: AttributeState = {
  attributes: [],
  attributeToEdit: null,
};

const AttributeSlice = createSlice({
  name: "Attribute",
  initialState,
  reducers: {
    setAttributeList: (state, action: PayloadAction<IAttribute[]>) => {
      state.attributes = action.payload;
    },
    concatListAttribute: (
      state: AttributeState,
      action: PayloadAction<IAttribute[]>
    ) => {
      state.attributes = [...state.attributes.concat(action.payload)];
    },
    setAttributeToEdit: (state, action: PayloadAction<IAttribute | null>) => {
      state.attributeToEdit = action.payload;
    },
    addAttribute: (state, action: PayloadAction<IAttribute>) => {
      state.attributes.push(action.payload);
    },
    updateAttribute: (state, action: PayloadAction<IAttribute>) => {
      let itemIndex = state.attributes.findIndex(
        item => item.attributeId === action.payload.attributeId
      );
      if (itemIndex !== -1) state.attributes[itemIndex] = action.payload;
    },
    deleteAttribute: (state, action: PayloadAction<number>) => {
      const newArray = state.attributes.filter(
        item => item.attributeId !== action.payload
      );
      state.attributes = newArray;
    },
  },
});

export const {
  setAttributeList,
  concatListAttribute,
  setAttributeToEdit,
  addAttribute,
  updateAttribute,
  deleteAttribute,
} = AttributeSlice.actions;

export default AttributeSlice.reducer;
